function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useColorBoard } from '../../hooks/color';
import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { ColorLayer } from './components/ColorLayer';
export function ColorBoard(props) {
  var className = props.className,
      extra = _objectWithoutProperties(props, ["className"]);

  var cls = classnames(usePrefixCls('color-board'), className);
  var rgba = useColorBoard();
  var a = (rgba.a / 100).toFixed(2);
  return React.createElement("div", Object.assign({}, extra, {
    className: cls
  }), React.createElement(ColorLayer, {
    type: "alpha"
  }), React.createElement(ColorLayer, {
    type: "rgba(".concat(rgba.r, ", ").concat(rgba.g, ", ").concat(rgba.b, ", ").concat(a, ")")
  }));
}